module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kIsB5"))).then(() => parcelRequire('dJXJK'));